import script from "./NossosClienteComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./NossosClienteComponent.vue?vue&type=script&setup=true&lang=js"

import "./NossosClienteComponent.vue?vue&type=style&index=0&id=234892ac&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-234892ac"]])

export default __exports__